var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Value)?_c('cg-edit-form',{attrs:{"colInfo":_vm.CfgDescCfgColInfo},model:{value:(_vm.Value),callback:function ($$v) {_vm.Value=$$v},expression:"Value"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }